@if (fromSideNav) {
  <div class="main-content">
    <div class="container-fluid">
      <div class="card sq-card">
        <div class="card-header card-header-squirrel">
          <h4>{{this.translate.data['TENANTGROUPROLES'] | translate}}</h4>
          <!-- <button matTooltip="{{this.translate.data['ADDTENANTGROUPROLE'] | translate}}" mat-raised-button class="btn btn-squirrel pull-right"  (click)="addTenantGroupRole()">
          <mat-icon>add</mat-icon>
        </button>
        <div class="clearfix"></div> -->
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-8">
            <!-- <button matTooltip="{{this.translate.data['ADDTENANTGROUPROLE'] | translate}}"
            mat-button matSuffix mat-icon-button (click)="addTenantGroupRole()">
            <mat-icon>add</mat-icon>
          </button> -->
          <a>
            <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;margin-left: 5px" matTooltip="{{this.translate.data['ADDTENANTGROUPROLE'] | translate}}" (click)="addTenantGroupRole()">Neue Gruppe</button>
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 tenant-grouproles-board-body-table">
          @if (isLoadingResults || isRateLimitReached) {
            <div class="example-loading-shade">
              @if (isLoadingResults) {
                <mat-spinner></mat-spinner>
              }
              @if (isRateLimitReached) {
                <div class="example-rate-limit-reached">
                  Squirrel's API rate limit has been reached. It will be reset in one minute.
                </div>
              }
            </div>
          }
          <ag-grid-angular style="width:100%;  height: 100%; padding: 5px;"
            class="ag-theme-balham"
            [overlayLoadingTemplate]="overlayLoadingTemplate"
            [gridOptions]="gridOptions"
            (gridReady)="onGridReady($event)"
            [components]="components">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
}

@if (!fromSideNav) {
  <div class="sq-card" >
    <div class="card-body">
      @if (!selectTGRforuser) {
        <div class="row">
          <div class="row">
            <div class="col-md-12">
              <a>
                <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;margin-left: 15px" matTooltip="{{this.translate.data['ADDTENANTGROUPROLE'] | translate}}" (click)="addTenantGroupRole()">Neue Gruppe</button>
              </a>
            </div>
          </div>
        </div>
      }
      @if (selectTGRforuser) {
        <div class="row">
          <div class="row">
            <div class="col-md-8 d-flex align-items-center">
              <a>
                <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px; margin-left: 15px; white-space: nowrap;" matTooltip="Ausgewählte Mandantengruppen dem Benutzer zuweisen"
                (click)="assignTGRtoUser()">Gruppe(n) zuweisen</button>
              </a>
              @if (_userRoles.includes('MANAGE_AUDIT') || _userRoles.includes('TENANTADMIN') || _userRoles.includes('admin')) {
                <a>
                  <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px; margin-left: 10;" matTooltip="Excel Datei erstellen mit Vorgängen bzgl. Mandantengrupppenrollen für den angezeigten Benutzer" (click)="exportAuditData()">Export Audit Log</button>
                </a>
              }
            </div>
          </div>
        </div>
      }
      <div class="tenant-grouproles-board-body-table">
        @if (isLoadingResults || isRateLimitReached) {
          <div class="example-loading-shade">
            @if (isLoadingResults) {
              <mat-spinner></mat-spinner>
            }
            @if (isRateLimitReached) {
              <div class="example-rate-limit-reached">
                Squirrel's API rate limit has been reached. It will be reset in one minute.
              </div>
            }
          </div>
        }
        <ag-grid-angular class="ag-theme-balham" style="width:100%;  height: calc(100vh - 430px);  padding: 0px;"
          [overlayLoadingTemplate]="overlayLoadingTemplate"
          [gridOptions]="gridOptions"
          (gridReady)="onGridReady($event)"
          [components]="components">
        </ag-grid-angular>
      </div>
    </div>
  </div>
}
